import React from 'react';
import { AcmpType } from '../../../utils';

interface AcmpLocationProps {
  acmp: AcmpType;
  setAcmp: React.Dispatch<React.SetStateAction<AcmpType>>;
}
const AcmpLocation: React.FC<AcmpLocationProps> = ({ acmp, setAcmp }) => {
  return (
    <div className="govuk-form-group">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="acmp-location">
          The location of the ACMP document
        </label>
      </h1>
      <textarea
        className="govuk-textarea"
        id="acmp-location"
        name="AcmpLocation"
        rows={5}
        aria-describedby="acmp-location"
        placeholder="The location of the ACMP"
        value={acmp.location}
        onChange={e => {
          setAcmp(prev => ({
            ...prev,
            location: e.target.value,
          }));
        }}
      />
    </div>
  );
};

export default AcmpLocation;
